import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Container, Row } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const navigate = useNavigate();
  const [cartData, setCartData] = useState([]);
  const [totalPrice, setTotalPrice] = useState();
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("cartItems"))) {
      setCartData(JSON.parse(localStorage.getItem("cartItems")));
    }
  }, []);
  const dec = (e) => {
    if (e.quantity <= 1) {
      let updatedArray = cartData.filter((item) => item._id !== e._id);
      let addedArr = updatedArray.map((items) => items._id);
      localStorage.setItem("addedProducts", JSON.stringify(addedArr));
      localStorage.setItem("cartItems", JSON.stringify(updatedArray));
      setCartData(updatedArray);
      navigate("/cart");
    } else {
      const indexToUpdate = cartData.findIndex((obj) => obj._id === e._id);
      const updatedObject = {
        ...cartData[indexToUpdate],
        quantity: e.quantity - 1,
      };
      const updatedArray = [
        ...cartData.slice(0, indexToUpdate),
        updatedObject,
        ...cartData.slice(indexToUpdate + 1),
      ];
      setCartData(updatedArray);
      localStorage.setItem("cartItems", JSON.stringify(updatedArray));
    }
  };
  const inc = (e) => {
    console.log("#####e", e);
    const indexToUpdate = cartData.findIndex((obj) => obj._id === e._id);
    const updatedObject = {
      ...cartData[indexToUpdate],
      quantity: e.quantity + 1,
    };
    const updatedArray = [
      ...cartData.slice(0, indexToUpdate),
      updatedObject,
      ...cartData.slice(indexToUpdate + 1),
    ];
    console.log("updatedArray", updatedArray);
    setCartData(updatedArray);
    localStorage.setItem("cartItems", JSON.stringify(updatedArray));
  };
  const handleChange = (cart, e) => {
    console.log("#######", e.target.value);
    var digit = e.target?.value?.replace(/\D/g, "");
    if (digit < 1) {
      let updatedArray = cartData.filter((item) => item._id !== cart._id);
      let addedArr = updatedArray.map((items) => items._id);
      localStorage.setItem("addedProducts", JSON.stringify(addedArr));
      localStorage.setItem("cartItems", JSON.stringify(updatedArray));
      setCartData(updatedArray);
      navigate("/cart");
    } else {
      const indexToUpdate = cartData.findIndex((obj) => obj._id === cart._id);
      const updatedObject = {
        ...cartData[indexToUpdate],
        quantity: Number(digit),
      };
      const updatedArray = [
        ...cartData.slice(0, indexToUpdate),
        updatedObject,
        ...cartData.slice(indexToUpdate + 1),
      ];
      setCartData(updatedArray);
      localStorage.setItem("cartItems", JSON.stringify(updatedArray));
    }
  };
  const handleCheckout = async () => {
    localStorage.setItem("Usercart", JSON.stringify({ cartData, totalPrice }));
    navigate("/checkout");
  };
  const handleRemove = (e) => {
    let updatedArray = cartData.filter((item) => item._id !== e._id);
    let addedArr = updatedArray.map((items) => items._id);
    localStorage.setItem("addedProducts", JSON.stringify(addedArr));
    localStorage.setItem("cartItems", JSON.stringify(updatedArray));
    setCartData(updatedArray);
    navigate("/cart");
  };
  useEffect(() => {
    const price = cartData
      .map((item) => item.salePrice * item.quantity)
      .reduce((sum, num) => {
        return sum + num;
      }, 0);
    setTotalPrice(price.toFixed(2));
  }, [cartData]);
  return (
    <>
      <div className="main">
        <Container className="py-5">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            {cartData.map((items) => {
              return (
                <Breadcrumb.Item>
                  <small
                    className="BreadCrumbs_style"
                    onClick={() =>
                      navigate(`/product/${items.name.replace(/\s+/g, "")}`)
                    }
                  >
                    {items.name}
                  </small>
                </Breadcrumb.Item>
              );
            })}

            <Breadcrumb.Item active>
              <small className="BreadCrumbs_style">Cart</small>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col xxl="12">
              <Card className="box_shadow">
                <Card.Header className="blue_bg Card_Header">
                  <Container>
                    <Row>
                      <Col
                        md="6"
                        lg="6"
                        xl="7"
                        className="Header_Text px-0 ps-5 cart_heading_start"
                      >
                        Product
                      </Col>
                      <Col
                        md="3"
                        lg="3"
                        xl="2"
                        className="Header_Text d-flex justify-content-center px-0"
                      >
                        <div className="cart_card_heading me-3">Quantity</div>
                      </Col>
                      <Col
                        md="2"
                        lg="2"
                        xl="2"
                        className="Header_Text d-flex justify-content-center px-0"
                      >
                        <div className="cart_card_heading me-3">Total</div>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body>
                  {cartData.length === 0 ? (
                    <h6 className="Cart_Card_Head black_text">
                      <b>No product found, Please add product first</b>
                    </h6>
                  ) : (
                    <Container className="shop_Cart">
                      {cartData.map((cartData, index) => {
                        return (
                          <>
                            <Row className="Cart_row py-2">
                              <Col
                                md="6"
                                lg="6"
                                xl="7"
                                className="Header_Text d-flex product_cart_column"
                              >
                                <img
                                  src={cartData.productImage}
                                  alt="product"
                                  className="cart_prod_img"
                                />
                                <div className="d-flex flex-column justify-content-center ">
                                  <h6 className="Cart_Product_head mt-2 text_muted">
                                    <b>
                                      {cartData.name} 32/64 Retail - Download &
                                      License Key
                                    </b>
                                  </h6>
                                  <p className="Cart_Paragraph text_muted">
                                    90-Day Hassle-Free Refund Policy 256-bit SSL
                                    Encrypted Checkout Genuine Software
                                    Guaranteed 24/7 Technical Support <br />
                                    Instant Delivery
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md="3"
                                lg="3"
                                xl="2"
                                className="Header_Text Center_Cart_btn"
                              >
                                <div className="Quantity_btn_div">
                                  <div className="Counter_btn_div">
                                    <Button
                                      className="p-1 px-4 me-2 Counter_Btn"
                                      onClick={() => dec(cartData)}
                                    >
                                      -
                                    </Button>
                                    <input
                                      type="text"
                                      value={cartData.quantity}
                                      onChange={(e) =>
                                        handleChange(cartData, e)
                                      }
                                      className="quantity_input"
                                    />

                                    <Button
                                      className="p-1 px-4 ms-2 Counter_Btn"
                                      onClick={() => inc(cartData)}
                                    >
                                      +
                                    </Button>
                                  </div>
                                </div>
                              </Col>
                              <Col
                                md="2"
                                lg="2"
                                xl="2"
                                className="Header_Text Center_Cart_btn"
                              >
                                <h6 className="text_muted">
                                  <b className="cart_product_price">
                                    {(
                                      cartData.quantity * cartData.salePrice
                                    ).toFixed(2)}{" "}
                                    USD
                                  </b>
                                </h6>
                              </Col>
                              <Col
                                md="1"
                                lg="1"
                                xl="1"
                                className="Header_Text Center_Cart_btn"
                              >
                                <BsXLg
                                  className="cursor_pointer"
                                  onClick={() => handleRemove(cartData)}
                                />
                              </Col>
                            </Row>
                            <hr />
                          </>
                        );
                      })}
                    </Container>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Container className="mt-5">
            <Row className="justify-content-between">
              <Col lg="7" className="Header_Text ps-0">
                <div>
                  <Card className="Cart_Small_Card box_shadow">
                    <Card.Body>
                      <h6 className="Cart_Card_Head black_text">
                        <b>Our Delivery Process</b>
                      </h6>
                      <div className="pb-3">
                        <p className="Cart_Card_Para black_text">
                          Our dedicated team is working hard behind the scenes
                          to ensure the delivery of your purchased software is
                          made available to you immediately upon the completion
                          of your purchase. Your software will be delivered via
                          electronic delivery. Therefore, you may access,
                          install, and activate your purchased software right
                          away.{" "}
                        </p>
                        <p className="Cart_Card_Para black_text">
                          We understand that digital downloads could be
                          overwhelming to some of our customers. Which is why we
                          offer around the clock support to make sure that every
                          single one of our customers are taken care of in a
                          timely manner. We encourage everyone to contact our
                          sales and support team to provide assistance with
                          their order.
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
              <Col lg="5" className="Header_Text Small_Card pe-0">
                <div>
                  <Card className="Cart_Smallest_Card box_shadow">
                    <Card.Body>
                      <h6 className="Cart_Smallest_cardHead text_muted m-0">
                        <b>Order Summary</b>
                      </h6>
                      <div className="d-flex justify-content-between Cart_Card_list">
                        <ul className="Card_ULlist">
                          <li className="Card_list text_muted">
                            Items Total ({cartData.length})
                          </li>
                          <li className="Card_list text_muted"> Delivery</li>
                          <li className="Card_list text_muted">Tax</li>
                          <li className="Card_list Card_LargeText text_muted">
                            <b>Subtotal</b>
                          </li>
                        </ul>
                        <ul className="Card_ULlist d-flex flex-column align-items-end">
                          <li className="Card_list text_muted">{totalPrice}</li>
                          <li className="Card_list text_muted"> Instant</li>
                          <li className="Card_list text_muted ">
                            Calculated At Checkout
                          </li>
                          <li className="Card_list text_muted">
                            <b>{totalPrice}</b>
                          </li>
                        </ul>
                      </div>
                      <div className="d-flex justify-content-center">
                        <Button
                          className="Card_Large_btn"
                          onClick={handleCheckout}
                          disabled={
                            localStorage.getItem("cartItems")
                              ? !JSON.parse(localStorage.getItem("cartItems"))
                                  .length > 0
                              : true
                          }
                        >
                          Proceed To Checkout
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default Cart;
